import React from 'react';
import { TeaserMedia } from '@src/interfaces';
import ParagraphProps from '@src/components/Paragraph/paragraph-props';
import OasisPlayer from '../OasisPlayer/OasisPlayer';

const CumulusVideoParagraph = ({ paragraph }: ParagraphProps) => {
  const teaserMedia = paragraph.data as TeaserMedia & { title: string; descriptionHtml: string };
  if (!teaserMedia?.video) {
    return null;
  }
  return (
    <section className="paragraph cumulus-video-paragraph">
      {teaserMedia.title ? <h3>{teaserMedia.title}</h3> : null}

      <OasisPlayer image={teaserMedia?.image} video={teaserMedia?.video} />

      {teaserMedia.descriptionHtml ? <span
        className="cumulus-video-description"
          // eslint-disable-next-line
          dangerouslySetInnerHTML={{ __html: teaserMedia?.descriptionHtml }}
        /> : null}
    </section>
  );
};

export default CumulusVideoParagraph;
